"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const vuex_1 = __importDefault(require("vuex"));
const User_1 = __importDefault(require("./modules/User"));
const Market_1 = __importDefault(require("./modules/Market"));
const Server_1 = __importDefault(require("./modules/Server"));
const Firebase_1 = __importDefault(require("./modules/Firebase"));
const Actions_1 = __importDefault(require("./Actions"));
vue_1.default.use(vuex_1.default);
const debug = process.env.NODE_ENV !== 'production';
exports.default = new vuex_1.default.Store({
    modules: {
        User: User_1.default,
        Market: Market_1.default,
        Server: Server_1.default,
        Firebase: Firebase_1.default
    },
    actions: Actions_1.default,
    strict: debug,
});
